import React from "react";
import BaseApi from "../../utils/BaseApi";
import {CircularProgress} from "@mui/joy";
import CommonDetail from "../Common/CommonDetail";
import withRouter from "../../utils/withRouter";

// components
import AttachmentsTab from "../Attachment/AttachmentsTab";
import ApplicantDetailHeader from "./ApplicantDetailHeader";
import ApplicantTab from "./ApplicantTab";
import ApplicantExternalTab from "./ApplicantExternalTab";

// icons
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import WorkIcon from '@mui/icons-material/Work';
import UserSubscriberContext from "../../context/UserSubscriberContext";

class ApplicantDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            applicant: null,
        };
    }

    async componentDidMount() {
        await this.retrieveApplicant();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveApplicant();
        }
    }

    async retrieveApplicant() {
        this.setState(
            {
                applicant: null
            }
        );
        const url = `applicant/${this.props.params.applicantId}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                applicant: response.data
            }
        );
    }

    render() {
        if (!this.state.applicant) {
            return (<CircularProgress/>)
        }
        return (
            <CommonDetail
                appName={'Applicant'}
                appId={this.state.applicant.id}
                header={{
                    component: ApplicantDetailHeader,
                    componentProps: {
                        applicant: this.state.applicant,
                        callBack: this.retrieveApplicant.bind(this),
                    },
                    leftOverflow: {
                        icon: null,
                        title: 'Соискатель',
                        color: 'primary'
                    },

                }}
                defaultTabValue={'info'}
                tabComponents={[
                    {
                        title: 'Информация',
                        value: 'info',
                        icon: AccountTreeIcon,
                        component: <ApplicantTab
                            applicant={this.state.applicant}
                            callBack={this.retrieveApplicant.bind(this)}
                        />,
                    },
                    {
                        title: 'Вложения',
                        value: 'attachment',
                        icon: AttachFileIcon,
                        component: <AttachmentsTab
                            appId={this.state.applicant.id}
                            appName={'Applicant'}
                        />
                    },
                    {
                        title: 'Прием на работу',
                        value: 'external',
                        icon: WorkIcon,
                        hidden: !this.context.userObject.is_superuser,
                        component: <ApplicantExternalTab
                            applicant={this.state.applicant}
                            callBack={this.retrieveApplicant.bind(this)}
                        />,
                    },
                ]}
            />
        )
    }
}

export default withRouter(ApplicantDetail);
